import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function useIsMobileDevice() {
  const theme = useTheme();
  // In MUI v7, down("xs") is effectively unusable because xs is the lowest key.
  // Use down("sm") to target phone-sized viewports (<600px).
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"), {
    noSsr: true,
  });
  return isMobile;
}
